import { render, staticRenderFns } from "./JobsFilter.vue?vue&type=template&id=b72f74c8"
import script from "./JobsFilter.vue?vue&type=script&lang=ts"
export * from "./JobsFilter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports